module.exports = __webpack_public_path__ + "img/MPX2.dd772ae1.png";